import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ kicker, title, sub, testid }) => (
  <Reveal className="mb-14 md:mb-20 max-w-3xl">
    <p className="text-xs uppercase tracking-[0.3em] text-[#8a8dff] mb-5">{kicker}</p>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase leading-[1.02] tracking-tight" data-testid={testid}>{title}</h2>
    {sub && <p className="mt-6 text-base md:text-lg text-[#c9c6f0] leading-relaxed max-w-xl">{sub}</p>}
  </Reveal>
);
